import { Fragment } from "react"

function MultiValueDisplay({
  displayList,
  fieldKey,
  inert,
  readOnly,
  preventClickHandler,
  showLinkIcon,
  displayValue,
  Viewer,
}) {
  return (
    <Fragment>
      <div className="truncate">
        {displayList.map((displayEl, i) => {
          const lastElement = i === displayList.length - 1

          return (
            <Fragment key={i}>
              {displayValue && (
                <>
                  {Viewer(
                    fieldKey,
                    displayEl,
                    inert,
                    readOnly,
                    preventClickHandler,
                    showLinkIcon
                  )}
                </>
              )}
              {!lastElement && ", "}
            </Fragment>
          )
        })}
      </div>
    </Fragment>
  )
}
export default MultiValueDisplay
